import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export enum BlendMode {
  MULTIPLY = 'multiply',
  NORMAL = 'normal',
  NONE = ''
}

export const BackgroundSchema = z.object({
  color: z.string().max(255).nullable().default(null),
  blendMode: z.nativeEnum(BlendMode).nullable().default(BlendMode.NONE),
});

export type Background = z.infer<typeof BackgroundSchema>;

export const ImageSchema = BaseSchema.extend({
  sequenceNumber: z.number().default(0),
  default: z.boolean().nullable().default(false),
  annotations: z.array(z.string().uuid()).default([]),
  background: BackgroundSchema.nullable().optional(),
  pois: z.array(z.string().uuid()).default([]),
  layer: z.string().uuid(),
  link: FlatModels.LinkEntityModels.LinkSchema.optional(),
  media: z.string().uuid().nullable().optional(),
});

export type Image = z.infer<typeof ImageSchema>;

export const ImageEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: ImageSchema,
});

export type ImageEntityQueryResult = z.infer<typeof ImageEntityQueryResultSchema>;
